export default __webpack_public_path__ + "b0e748a20262eaad043d85477277669f.svg";